import {Injectable} from "@angular/core";
import {Actions, createEffect, ofType} from "@ngrx/effects";
import * as hostingZonesActions from '../actions/hosting-zones.action';
import {DbResponse} from "../../shared/interceptors/db-response";
import {filter, map, switchMap} from 'rxjs/operators';
import {HostingService} from "../../websites/website/hosting/hosting.service";
import {LOAD_ZONE, LoadZone} from "../actions";

@Injectable()
export class HostingZonesEffects {

  loadZone$ = createEffect(() => this._actions$.pipe(
    ofType(LOAD_ZONE),
    switchMap((action: LoadZone) => {
      const zoneId: number = action.payload.zoneId;
      return this._hostingService.getZoneById(zoneId)
        .pipe(
          filter((response: DbResponse) => !!response),
          map((response: DbResponse) => {
            if (response.success) {
              return new hostingZonesActions.LoadZoneSuccess({
                zoneId: zoneId,
                entities: response.data
              });
            }
            return new hostingZonesActions.LoadZoneFail(response.message);
          })
        );
    })
  ));

  constructor(
    private _actions$: Actions,
    private _hostingService: HostingService
  ) {
  }

}
